import styled from 'styled-components';

export const StyledControlContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
`;
